import {fetch} from "utils/dataAccess";
import {LineItemStatus} from "utils/LineItemStatus";

import {ITEM_PER_PAGE} from "config/_pagination";

export default async function list(params = `order[createdAt]=asc&itemsPerPage=${ITEM_PER_PAGE}&status=${LineItemStatus.PENDING}&page=1`)  {
    const response = await fetch(`/orders?${params}`);

    return await response.json();
}

export async function listAllNonConfirmedOrders(params= "") {
    const response = await fetch(`/orders/non-confirmed${params}`)

    return await response.json()
}
